module.exports = __webpack_public_path__ + "static/media/JMC1.fdf718f1.jpg";